import { lang, setLang } from '../lib/i18n.js';

/** English / বাংলা segmented switch. */
export function LangSwitch(props: { compact?: boolean }) {
  const cur = lang.value;
  return (
    <div class="seg" role="group" aria-label="Language" data-testid="lang-switch">
      <button
        type="button"
        class="seg-opt"
        aria-pressed={cur === 'en'}
        onClick={() => setLang('en')}
      >
        {props.compact ? 'EN' : 'English'}
      </button>
      <button
        type="button"
        class="seg-opt"
        aria-pressed={cur === 'bn'}
        onClick={() => setLang('bn')}
      >
        বাংলা
      </button>
    </div>
  );
}
